import type { IChallenge } from "@bbj-types/challenge";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "@mui/material";
import { PaperButtonCollapse } from "@surfaces/PaperButtonCollapse";
import { useState } from "react";
import type { TPaperCandidateChallengeObjective } from "../types";
import { PaperCandidateObjectiveForm } from "./form";
import { PaperCreateCandidateObjectiveCollapse } from "./styles";

export interface IPaperCreateCandidateObjectiveProps {
  disabled?: boolean;
  challenge: Pick<IChallenge, "objectives">;
  onSubmit: (candidateObjective: TPaperCandidateChallengeObjective) => void | Promise<void>;
}

export const PaperCreateCandidateObjective = ({
  disabled,
  challenge,
  onSubmit,
}: IPaperCreateCandidateObjectiveProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleSubmit = async (candidateObjective: TPaperCandidateChallengeObjective) => {
    setLoading(true);
    try {
      await onSubmit(candidateObjective);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <PaperButtonCollapse
      open={open}
      onToggleOpen={disabled || loading ? undefined : setOpen}
      label={
        <>
          <AddIcon color="primary" sx={{ ml: "-5px" }} />
          <Typography variant="subtitle2SemiBold" color="primary">
            Renseigner un objectif
          </Typography>
        </>
      }
      slotProps={{
        labelStack: {
          direction: "row",
          alignItems: "center",
          py: 1,
          px: 3,
          gap: 1,
        },
        collapseStack: {
          component: PaperCreateCandidateObjectiveCollapse,
        },
      }}
    >
      <PaperCandidateObjectiveForm
        disabled={disabled}
        open={open}
        challenge={challenge}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </PaperButtonCollapse>
  );
};
